import { render } from "./GeolocationFromZipCodes.vue?vue&type=template&id=670ee246&ts=true"
import script from "./GeolocationFromZipCodes.vue?vue&type=script&lang=ts"
export * from "./GeolocationFromZipCodes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__